/**
 * 波特率选择器组件
 * 提供常见波特率的下拉选择
 */
import { useSerialPorts } from '@/hooks/use-serial-ports';
import { useConnectionStore } from '@/stores/connection';
import { MCP_BAUD_RATES } from '@fluxlab/protocols';
import { ChevronDown } from 'lucide-react';
import * as Select from '@radix-ui/react-select';

/** 波特率选择器：提供常用串口波特率选项并同步到连接 Store */
export function BaudSelector() {
  const baudRate = useConnectionStore((s) => s.baudRate);
  const setBaudRate = useConnectionStore((s) => s.setBaudRate);
  const isConnected = useConnectionStore((s) => s.state === 'connected');

  return (
    <Select.Root
      value={String(baudRate)}
      onValueChange={(v) => setBaudRate(parseInt(v))}
      disabled={isConnected}
    >
      <Select.Trigger
        aria-label="波特率"
        className="inline-flex h-9 min-w-[116px] items-center justify-between gap-2 rounded border border-surface-700
          bg-surface-800 px-3 font-mono text-xs text-surface-200
          focus:border-accent-500 disabled:cursor-not-allowed disabled:opacity-50"
      >
        <Select.Value />
        <Select.Icon>
          <ChevronDown className="w-4 h-4 text-surface-500" />
        </Select.Icon>
      </Select.Trigger>
      <Select.Portal>
        <Select.Content
          className="z-50 overflow-hidden rounded-md border border-surface-600 bg-surface-800 shadow-2xl"
          position="popper"
        >
          <Select.Viewport className="p-1">
            {MCP_BAUD_RATES.map((rate) => (
              <Select.Item
                key={rate}
                value={String(rate)}
                className="cursor-pointer rounded px-3 py-2 font-mono text-sm text-surface-200 outline-none hover:bg-surface-700
                  data-[state=checked]:bg-accent-500/10 data-[state=checked]:text-accent-300"
              >
                <Select.ItemText>{rate.toLocaleString()} bps</Select.ItemText>
              </Select.Item>
            ))}
          </Select.Viewport>
        </Select.Content>
      </Select.Portal>
    </Select.Root>
  );
}
